interface HeroFormSuccessProps {
  title: string;
  body: string;
  /** When present, renders a "View content" link (PDF download path). */
  pdfUrl?: string;
}

/**
 * Shared success state for the DRLP hero form — rendered by both the native
 * progressive-profiling form and the Content Registration fallback so the
 * post-submission experience is identical regardless of which form was shown.
 */
export function HeroFormSuccess({ title, body, pdfUrl }: HeroFormSuccessProps) {
  return (
    <div className="border-current/10 bg-chalk relative my-6 flex w-full max-w-[520px] flex-col items-center justify-center gap-2 border px-6 py-12 text-center md:px-8 md:py-16">
      <h3 className="text-heading-5">{title}</h3>
      <p className="text-body text-current/70 max-w-[450px]">{body}</p>
      {pdfUrl && (
        <a
          href={pdfUrl}
          className="text-inline-link mt-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          View content
        </a>
      )}
    </div>
  );
}
